import API from './api';

export const fetchCoursesList = () =>
  API.get('/courses')
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const fetchCourse = courseId =>
  API.get(`/Course/${courseId}`)
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const fetchNextLesson = courseId =>
  API.get(`/course/${courseId}/nextLesson`)
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const fetchHtmlCertificate = courseId =>
  API.get(`/course/${courseId}/certificate`)
    .then(res => res)
    .catch(err => {
      throw err;
    });
